import { DEFAULT_PAGE_SIZE } from '../PageSizeSelect/PageSizeSelect.constants'

export const INITIAL_FILTERS_VALUES = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE.toString(),
  orderId: '',
  startDate: '',
  endDate: '',
  isBackship: '',
  sku: '',
  customerFirstName: '',
  customerLastName: '',
  market: '',
  state: '',
  dateType: '',
  orderLineId: '',
  missingAction: '',
  carrierId: '',
}

export const OPTION_VALUE_ALL = ''
